import { render, staticRenderFns } from "./Resend.vue?vue&type=template&id=103ec325&"
import script from "./Resend.vue?vue&type=script&lang=js&"
export * from "./Resend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports